import React, { useEffect, useState } from 'react';

import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js';
import { DocumentsByProcessType, DocumentsByUser, Statistics, TimelineData } from '../../common/types/types';

ChartJS.register(Tooltip, Legend, ArcElement);

interface Props {
  statistics: TimelineData | DocumentsByUser | DocumentsByProcessType | undefined;
  title: string;
  //   graphData: string;
}

interface PieDataset {
  label: string;
  data: number[];
  borderWidth: number;
  backgroundColor: string[]; // Ensure this can accept string arrays
  borderRadius: number;
}

export const PieChart = ({ statistics, title }: Props) => {
  const backgroundColors = ['#F07714', '#FAB005', '#228BE6', '#B8BBBE', '#7D1007', '#8481DD'];
  const [data, setData] = useState<{
    labels: string[];
    datasets: PieDataset[]; // Use the defined dataset type
  }>({
    labels: [''],
    datasets: [
      {
        label: 'Number of documents',
        data: [],
        borderWidth: 1,
        backgroundColor: [], // Use only the necessary colors
        borderRadius: 5,
      },
    ],
  });

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: title,
        font: {
          size: 24,
          family: 'ManropeRegular',
        },
      },
    },
  };

  useEffect(() => {
    if (statistics) {
      const labels1 = Object.keys(statistics);
      const labels = labels1.map((label) => {
        return label === '' ? 'empty' : label;
      });
      const values = Object.values(statistics);
      setData({
        labels,
        datasets: [
          {
            label: 'Number of documents',
            data: values,
            borderWidth: 1,
            backgroundColor: backgroundColors.slice(0, labels.length), // Use only the necessary colors
            borderRadius: 5,
          },
        ],
      });
    }
  }, [statistics]);

  return (
    <div className='pie-graph'>
      <Pie options={options} data={data} />
    </div>
  );
};
